/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogInput } from '@gh/core-ui';
import { difference } from 'lodash';
import { DashboardManageDialogConfig, WidgetsModel } from '../../resources';

@Component({
  standalone: false,
  selector: 'gh-dashboard-manage-dialog',
  templateUrl: 'dashboard-manage-dialog.component.html',
  styleUrls: ['dashboard-manage-dialog.component.scss'],
})
export class DashboardManageDialogComponent implements DialogInput<DashboardManageDialogConfig>, OnInit {
  input: DashboardManageDialogConfig;
  widgets: WidgetsModel[] = [];
  ordersSeq: number[] = Array.from({ length: 6 }, (value, key) => key + 1);
  orderChanged: boolean = false;

  constructor(private dialogRef: MatDialogRef<any>) {
  }

  get widgetsSelected(): WidgetsModel[] {
    return this.widgets.filter((widget) => widget.isSelected);
  }

  get widgetsOrders(): number[] {
    return <number[]>this.widgets
      .map((widget) => widget.order)
      .filter((order) => !!order);
  }

  get widgetsLeftOrders(): number[] {
    return difference(this.ordersSeq, this.widgetsOrders);
  }

  isWidgetDisabled(widget: WidgetsModel): boolean {
    return !this.widgetsLeftOrders.length && !widget.order;
  }

  ngOnInit(): void {
    this.widgets = this.input.widgets;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    this.dialogRef.close(this.widgets);
  }

  getWidgetName(widget: WidgetsModel): string {
    return widget.name[this.input.localeIndex];
  }

  setOrders(widgetModel: WidgetsModel, isChecked: boolean): void {
    if (isChecked) {
      if (this.widgetsLeftOrders.length) {
        widgetModel.order = this.widgetsLeftOrders[0];
      }
    } else {
// @ts-expect-error Legacy typing suppression
      delete widgetModel.order;
    }

    this.widgets
      .filter((widget) => widget.order)
      .sort((widgetA, widgetB) => widgetA.order - widgetB.order)
      .forEach((widget, i) => widget.order = this.ordersSeq[i]);

    this.orderChanged = true;
  }
}
